import { render, staticRenderFns } from "./add_attachment.vue?vue&type=template&id=63e84372&scoped=true&"
import script from "./add_attachment.vue?vue&type=script&lang=js&"
export * from "./add_attachment.vue?vue&type=script&lang=js&"
import style0 from "./add_attachment.vue?vue&type=style&index=0&id=63e84372&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63e84372",
  null
  
)

export default component.exports